import { h } from "preact";
import pluralize from "../../helpers/pluralize";
import SwatchBasketChip from "./swatch-basket-chip";

export default function SwatchDetailsFooter({
  basket,
  swatchCatalogue,
  basketCount,
  canAddMore,
  hasChanges,
  submitting,
  error,
  onRemove,
  onSubmit,
}) {
  const strings = window.localeStrings.swatch_details;

  // Iterating the catalogue rather than the basket keeps the chips in grid
  // order — a plain object with numeric-string keys would sort them.
  const basketed = [...swatchCatalogue.entries()].filter(
    ([variantId]) => basket[variantId],
  );

  const submitLabel = () => {
    if (submitting) return window.localeStrings.product.adding_to_cart;
    if (!basketCount) return strings.add_to_cart_empty;

    return pluralize(basketCount, strings.add_to_cart);
  };

  return (
    <div className="swatch-details-drawer__footer">
      <div className="swatch-details-drawer__footer-summary">
        <div className="swatch-details-drawer__footer-summary-row">
          <span className="swatch-details-drawer__footer-count">
            {pluralize(basketCount, strings.selected_count)}
          </span>
          {!basketCount && (
            <span className="swatch-details-drawer__footer-hint">
              {strings.select_prompt}
            </span>
          )}
        </div>
        {!canAddMore && (
          <p className="swatch-details-drawer__footer-limit">
            {strings.limit_reached}
          </p>
        )}
      </div>
      {basketed.length > 0 && (
        <div className="swatch-details-drawer__basket">
          {basketed.map(([variantId, entry]) => (
            <SwatchBasketChip
              key={variantId}
              entry={entry}
              quantity={basket[variantId]}
              onRemove={() => onRemove(variantId)}
            />
          ))}
        </div>
      )}
      <button
        type="button"
        className="button button--black button--full swatch-details-drawer__submit"
        disabled={!hasChanges || submitting}
        onClick={onSubmit}
      >
        {submitLabel()}
      </button>
      {error && <p className="swatch-details-drawer__footer-error">{error}</p>}
    </div>
  );
}
